function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M16.19 2h-3.44v11.75H22V7.81C22 4.17 19.83 2 16.19 2zM2 10.25v5.94C2 19.83 4.17 22 7.81 22h3.44V10.25H2zM11.25 2v6.75H2v-.94C2 4.17 4.17 2 7.81 2h3.44zM22 15.25v.94c0 3.64-2.17 5.81-5.81 5.81h-3.44v-6.75H22z"
})));